import { useState } from "react";
import { ChevronDown, RotateCcw, Settings, Trash2 } from "lucide-react";

export function Shell({ activeView, navItems, onNavigate, onReset, onClear, pageTitleOverride, hidePageTitle, userLabel, busy, children }) {
  const activeItem = navItems.flatMap((item) => [item, ...(item.children || [])]).find((item) => item.id === activeView);
  const activeLabel = activeItem?.label || "학원 일정";
  const [openNavGroups, setOpenNavGroups] = useState(() => new Set(["messages"]));

  return (
    <div className="app-shell">
      <aside className="sidebar" aria-label="주요 메뉴">
        <div className="brand">
          <div className="brand-mark">FOTI</div>
          <div>
            <strong>학원 학생 관리</strong>
            <span>운영 통합 워크스페이스</span>
          </div>
        </div>

        <nav className="nav">
          {navItems.filter((item) => item.id !== "academy").map((item) => {
            const Icon = item.icon;
            const hasChildren = item.children?.length;
            const hasActiveChild = item.children?.some((child) => child.id === activeView);
            const isOpen = openNavGroups.has(item.id) || hasActiveChild;
            if (hasChildren) {
              return (
                <div key={item.id} className={`nav-group ${hasActiveChild ? "active" : ""}`}>
                  <button
                    className={`nav-item nav-group-trigger ${hasActiveChild ? "active" : ""}`}
                    onClick={() => setOpenNavGroups((current) => {
                      const next = new Set(current);
                      if (next.has(item.id)) next.delete(item.id);
                      else next.add(item.id);
                      return next;
                    })}
                    aria-expanded={isOpen}
                  >
                    <Icon size={17} />
                    <span>{item.label}</span>
                    <ChevronDown size={15} className={isOpen ? "is-open" : ""} />
                  </button>
                  {isOpen && <div className="nav-submenu">
                    {item.children.map((child) => (
                      <button key={child.id} className={`nav-submenu-item ${activeView === child.id ? "active" : ""}`} onClick={() => onNavigate(child.id)}>{child.label}</button>
                    ))}
                  </div>}
                </div>
              );
            }
            return (
              <button key={item.id} className={`nav-item ${activeView === item.id ? "active" : ""}`} onClick={() => onNavigate(item.id)}>
                <Icon size={17} />
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>

        {navItems.some((item) => item.id === "academy") && <button className={`settings-card ${activeView === "academy" ? "active" : ""}`} onClick={() => onNavigate("academy")}>
          <Settings size={18} />
          <div>
            <strong>학원 관리</strong>
            <span>선생님 · 수업 설정</span>
          </div>
        </button>}
      </aside>

      <main className={`main ${activeView}-main`}>
        <header className="topbar">
          <div>
            {!hidePageTitle && <h1>{pageTitleOverride || activeLabel}</h1>}
          </div>
          <div className="top-actions"><span className="meta">{userLabel}</span>
            <button className="ghost-button" disabled={busy} onClick={onReset}>
              <RotateCcw size={16} /> 새로고침
            </button>
            <button className="danger-button" onClick={onClear}>
              <Trash2 size={16} /> 로그아웃
            </button>
          </div>
        </header>
        {children}
      </main>
    </div>
  );
}
